module.exports = __webpack_public_path__ + "1_0_57/img/todoist.b0a3b3d9.svg";